import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledChip = styled(MuiChip)(() => {
  return {
    backgroudColor: brandColors.cardBorderColor,
  };
});

type ChipProps = MuiChipProps;

export const ComingSoonPill: React.FC<ChipProps> = ({ ...props }) => {
  return <StyledChip label="Coming Soon" {...props} />;
};

export default ComingSoonPill;
